import { createNamespacedHelpers } from 'vuex'
import { DateFactory } from 'rhg-vue-common'

const { mapGetters, mapActions } = createNamespacedHelpers('discovery')

export const hotelMixin = {
  data() {
    return {
      hotelsInMapView: []
    }
  },
  computed: {
    ...mapGetters(['hotels'])
  },
  methods: {
    ...mapActions(['navigateToHotels']),
    async showHotelMap(hotelCodes) {
      this.hotelsInMapView = hotelCodes.map(code => this.hotels.find(hotel => hotel.code === code))
      await this.navigateToHotels({
        hotels: this.hotelsInMapView,
        requestGalleries: false,
        onFilters: false
      })
    },
    onBookNow(hotelCode, isMemberOnlyRate, hotelName) {
      const offersData = {
        onlyMembers: window.Cookie.read('auth') || isMemberOnlyRate || false,
        started: true,
        reservationStartDate: DateFactory.formatDate(DateFactory.now()),
        hotelCode: hotelCode,
        hotelName: hotelName,
        minimumNights: 1,
        hotelCodes: [hotelCode]
      }
      global.searchBarVue.$emit('showPriceCalendar', offersData)
    }
  }
}
